export default __webpack_public_path__ + "static/media/choosing-first-card.cf27255a.svg";